import { render, staticRenderFns } from "./ArtworkMediaLegend.vue?vue&type=template&id=00705e5b"
import script from "./ArtworkMediaLegend.vue?vue&type=script&lang=js"
export * from "./ArtworkMediaLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports